import type {Component} from 'grapesjs';

/** The platforms added by default on a fresh social component. */
export const DEFAULT_SOCIAL_IDS = ['facebook', 'instagram', 'x', 'pinterest'] as const;

export const SOCIAL_ICONS_DIRECTORY_NAME = '/social-icons/';

/** Cache key for the available social link platforms list. */
export const SOCIAL_LINKS_CACHE_KEY = 'social-links-html-v3';

/** Length of the 'https://' prefix stripped from base URLs shown as placeholders. */
export const HTTPS_PREFIX_LENGTH = 8;

const HTTPS_PREFIX = 'https://';

/** Strips a leading 'https://' from a URL for display as a placeholder. */
export function stripHttpsPrefix(url: string): string {
  return url.startsWith(HTTPS_PREFIX) ? url.substring(HTTPS_PREFIX_LENGTH) : url;
}

/** Data available about a single social platform returned by `emailmaker/getSocialLinksURLs`. */
export interface SocialLinkPlatformData {
  id: string;
  name: string;
  baseURL: string;
  logos: Record<string, string>;
  type?: string;
}

/** Response shape from `emailmaker/getSocialLinksURLs`, after window.PMW.readLocal unwraps the transport envelope. */
export interface SocialLinksAPIResponse {
  socialLinks: SocialLinkPlatformData[];
}

/** The data extracted from one existing PMW_SOCIALS_IMAGE child component, representing one row. */
export interface SocialLinkRowData {
  id: string;
  logoURL: string;
  baseURL: string;
  platformURL: string;
  platformName: string;
  imageComponent: Component;
}
